// Exports:
export const FLEX = `
  display: flex;
  justify-content: center;
  align-items: center;
`
